import { useState } from "react";
import { Map, List } from "immutable";

const ARRAY = "array";
const OBJECT = "object";

const canConvert = (value) => [ARRAY, OBJECT].includes(typeof value);
const convertToImmutable = (value) => {
  const typeMap = {
    [ARRAY]: () => new List(value),
    [OBJECT]: () => new Map(value),
  };

  return typeMap[typeof value]();
};

const isImmutable = (value) => Map.isMap(value) || List.isList(value);

const useImmutableState = (initialValue = new Map()) => {
  const [value, setValue] = useState(initialValue);

  const updateState = (valueOrFunction) => {
    const computedVal =
      typeof valueOrFunction === "function" ? valueOrFunction(value) : valueOrFunction;

    if (isImmutable(computedVal) && !value.equals(computedVal)) {
      return setValue(computedVal);
    }
    // convert and set value if possible
    if (canConvert(computedVal)) {
      const convertedValue = convertToImmutable(computedVal);
      return setValue(convertedValue);
    }

    console.error("Invalid value passed as immutable state");
  };

  return [value, updateState];
};

export default useImmutableState;
